module.exports = __webpack_public_path__ + "img/Rectangle 172.b8c0462d.png";